export type Engine = {
  id?: any
  name: string
  place_id: any
  company_id: any
  brand?: string
  model?: string
  nominal_voltage?: string | number
}

export const en: any = {
  company_id: 4,
  id: 1,
  name: 2,
  place_id: 3,
}
